export enum MediaType {
	Reporting = 1,
	Files = 2,
	Import = 3,
	MailAttachment = 4,
	WordReportDocx = 5,
	WordReportPdf = 6
}